<template>
    <div :class="containerClass">
        <label :for="id" class="fw-bold" :style="labelStyle">
            {{ label }}
            <span v-if="required" class="required-fields">*</span>
        </label>
        <Multiselect
            v-model="localValue"
            :options="options"
            :multiple="true"
            :disabled="disabled"
            :searchable="searchable"
            :placeholder="placeholder"
            :label="labelKey"
            :id="id"
            :close-on-select="false" 
            :create-option="false"
            mode="tags"
        />
        <span v-if="required && errorStatus && modelValue.length === 0" class="text-danger mt-1" :style="errorMsgStyle">
            Select {{label}}
        </span>
    </div>
  </template>
<style src="@vueform/multiselect/themes/default.css"></style>  
<script>
import Multiselect from '@vueform/multiselect'
  
export default {
    name: "BaseMultiSelect",
    components: {
        Multiselect
    },
    props: {
        label: {
            type: String,
            default: "Select options",
        },
        modelValue: {
            type: Array,
            default: () => [],
        },
        id: {
            type: String,
            default: "",
        },
        options: {
            type: Array,
            default: () => [],
        },
        required: {
            type: Boolean,
            default: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        labelStyle: {
            type: Object,
            default: () => ({
                fontSize: '14px',
            }),
        },
        errorMsgStyle: {
            type: Object,
            default: () => ({
                fontSize: '12px',
            }),
        },
        searchable: {
            type: Boolean,
            default: true,
        },
        placeholder: {
            type: String,
            default: "Select options",
        },
        labelKey: {
            type: String,
            default: "text",
        },
        errorStatus: {
            type: Boolean,
            default: false,
        },
        marginTop: {
            type: String,
            default: "mt-3",
        }
    },
    computed: {
        containerClass() {
            return `col-md-3 ${this.marginTop}`;
        },
        localValue: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit('update:modelValue', value);
            },
        },
    },
};
</script>
  
<style scoped>
    .required-fields {
        color: red;
    }
</style>
  